import { Button, Card, CardBody } from '@/common'
import { ReportSectionCardHeader } from './SectionCardHeader'
import { usePermissions } from '@/shared/hooks/usePermissions'
import { useTranslation } from 'react-i18next'

export default function ReportSectionCard({
  children,
  isComplete,
  isPending,
  onEdit,
  reportButtonText,
  title,
  isOptional = false,
  isViewMode = false,
  icon,
  emissions,
  completionPercentage,
  variant = 'default',
  warningText,
  isReportButtonDisabled = false
}: {
  children: React.ReactNode
  isComplete: boolean
  isPending?: boolean
  onEdit: () => void
  reportButtonText: string
  title: string
  isOptional?: boolean
  isViewMode?: boolean
  icon?: React.ReactNode
  emissions?: number
  completionPercentage?: number
  variant?: 'default' | 'warning'
  warningText?: string
  isReportButtonDisabled?: boolean
}) {
  const { t } = useTranslation()
  const { checkPermission } = usePermissions()
  const canEditReport = checkPermission('emissionReport', 'update')
  const editButton =
    (isComplete && !isViewMode) || (!isComplete && isPending) ? (
      <button onClick={onEdit} className="text-green-500 font-semibold">
        {t('common:actions.edit')}
      </button>
    ) : null
  const reportButton = isComplete ? null : (
    <Button
      variant="subtle"
      disabled={isViewMode || !canEditReport || isReportButtonDisabled}
      className="w-full"
      onClick={onEdit}
    >
      {reportButtonText}
    </Button>
  )
  return (
    <Card variant={variant}>
      <ReportSectionCardHeader
        title={title}
        editButton={isReportButtonDisabled ? null : editButton}
        isOptional={isOptional}
        icon={icon}
        emissions={emissions}
        completionPercentage={completionPercentage}
        variant={variant}
        warningText={warningText}
      />
      <CardBody>{isComplete || (!isComplete && isPending) ? children : reportButton}</CardBody>
    </Card>
  )
}
